import React from 'react';

interface LogoProps {
  size?: number;
  className?: string;
}

// Displays the DealOnce brand logo from the public folder.
// Place the file at public/dealonce-logo.png
const Logo: React.FC<LogoProps> = ({ size = 40, className = '' }) => {
  return (
    <img
      src={process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/dealonce-logo.png` : '/dealonce-logo.png'}
      alt="DealOnce"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
};

export default Logo;

